//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
export default {
  name: 'rb-header-editorial-wall',
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    isHeaderMobile() {
      return this.$mq === HEADER
    },
    titleIsVisible() {
      return this.$slots['title']
    },
    elementsExist() {
      return this.$slots['wall-products']
    },
    numberOfProducts() {
      if (!this.elementsExist) return 0
      const products = this.elementsExist.filter((element) => !!element.tag)
      return products.length
    },
    bannerExists() {
      return (
        this.elementsExist && !this.isMobile && !this.isHeaderMobile && this.$slots['wall-banner']
      )
    },
  },
}
